import styled from 'styled-components';
import { GREY_200 } from '../../theme';

export default styled.div`
  width: 100%;
  border: 1px solid ${GREY_200};
  margin-bottom: ${({ margin = 20 }) => margin}px;
`;
